<div class="container">
  <header>
    <svg width="102" height="24" viewBox="0 0 102 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.6805 3.56544C13.8989 3.44845 16.0923 4.0789 17.908 5.35544L18.3542 3.96944C16.2865 2.45034 13.7549 1.6927 11.1902 1.82544C3.59798 1.82544 0.641113 6.47944 0.641113 12.2254C0.641113 17.9714 3.59798 22.6254 11.1902 22.6254C13.7559 22.7589 16.2887 22.0012 18.3572 20.4814L17.908 19.0924C16.0904 20.3689 13.8954 20.9993 11.6755 20.8824C7.19254 20.8824 4.95759 17.0064 4.95759 12.2264C4.95759 7.44644 7.18853 3.57044 11.6755 3.57044"
        fill="#FFFFFF"
      />
      <path
        d="M89.3459 1.82422C81.7537 1.82422 78.7969 6.47822 78.7969 12.2242C78.7969 17.9702 81.7517 22.6242 89.3459 22.6242C96.9401 22.6242 99.895 17.9702 99.895 12.2242C99.895 6.47822 96.9401 1.82422 89.3459 1.82422ZM89.3459 21.3632C84.863 21.3632 83.1214 17.2712 83.1214 12.2222C83.1214 7.17321 84.866 3.08122 89.3459 3.08122C93.8258 3.08122 95.5705 7.17321 95.5705 12.2222C95.5705 17.2712 93.8258 21.3632 89.3459 21.3632Z"
        fill="#FFFFFF"
      />
      <path
        d="M57.1363 8.31513C57.1265 6.68571 56.4682 5.12689 55.3062 3.98147C54.1442 2.83605 52.5736 2.19782 50.9399 2.20713H42.8784V22.2361H47.1217V12.8151V3.46313H48.4843C49.6356 3.44689 50.7527 3.85296 51.6234 4.6042C52.4941 5.35545 53.0579 6.39952 53.2075 7.53806C53.3571 8.6766 53.0821 9.83028 52.4348 10.7799C51.7876 11.7296 50.8131 12.409 49.6966 12.6891H49.6885C49.5712 12.7191 49.4569 12.7471 49.3366 12.7671C49.2805 12.7771 49.2223 12.7851 49.1662 12.7921C49.0869 12.8051 49.0087 12.8171 48.9295 12.8221C48.7821 12.8351 48.6367 12.8451 48.4863 12.8451H47.1337L54.1584 22.2341H59.0304L52.9141 14.0971C54.1388 13.6973 55.206 12.9228 55.9641 11.8836C56.7223 10.8444 57.1328 9.59331 57.1373 8.30813"
        fill="#FFFFFF"
      />
      <path
        d="M75.6697 8.31516C75.6604 6.68592 75.0028 5.12704 73.8413 3.98128C72.6799 2.83551 71.1098 2.19665 69.4762 2.20516H61.4148V22.2362H65.6581V12.8152V3.46316H67.0207C68.1719 3.44692 69.289 3.85299 70.1598 4.60423C71.0305 5.35548 71.5942 6.39955 71.7438 7.53809C71.8934 8.67663 71.6184 9.83031 70.9712 10.7799C70.3239 11.7296 69.3495 12.409 68.2329 12.6892H68.2249C68.1076 12.7192 67.9903 12.7472 67.8729 12.7672C67.8168 12.7772 67.7587 12.7852 67.7025 12.7922C67.6233 12.8052 67.5451 12.8172 67.4659 12.8222C67.3205 12.8352 67.1701 12.8452 67.0227 12.8452H65.6661L72.6908 22.2342H77.5627L71.4465 14.0972C72.6712 13.6974 73.7384 12.9228 74.4965 11.8836C75.2546 10.8444 75.6651 9.59334 75.6697 8.30816"
        fill="#FFFFFF"
      />
      <path
        d="M39.2588 2.20613H36.7752V12.5811C36.7752 15.6441 36.5054 18.9811 33.5736 20.3811C32.6243 20.8524 31.5554 21.0301 30.5041 20.8915C29.4528 20.7529 28.4669 20.3042 27.673 19.6031C26.3384 18.2721 25.8391 15.6641 25.8391 10.8311V2.20613H21.4995V9.98113C21.4995 12.5291 21.4865 15.3381 22.3478 17.5121C23.551 20.5651 26.576 22.2271 29.8487 22.5231C31.09 22.6642 32.3472 22.5354 33.5338 22.1458C34.7205 21.7562 35.8085 21.115 36.723 20.2661C39.2297 17.8511 39.2628 14.5601 39.2628 10.6281V2.20312L39.2588 2.20613Z"
        fill="#FFFFFF"
      />
    </svg>
    <a (click)="closeDrawer()" aria-label="Close Drawer">
      <app-icon name="close" colour="white" />
    </a>
  </header>

  <div class="menu">
    @if (parent$ | async; as parent) {
      <div class="user" [routerLink]="['/guardians', parent.id, 'profile']" (click)="closeDrawer()">
        <app-avatar class="borderless-avatar" [avatar]="parent" />
        <div class="username">
          <p class="name">{{ formatUserName(parent.name) }}</p>
          <p class="vp">My profile</p>
        </div>
      </div>
    }

    <ul>
      @for (item of navItems(); track $index) {
        <li (click)="closeDrawer()" [routerLink]="item.link">
          <a>{{ item.label }}</a>
        </li>
      }
    </ul>
  </div>

  <div class="foot">
    <p class="text">Version: {{ currentApplicationVersion }}</p>

    <footer>
      <a routerLink="settings" aria-label="settings" (click)="closeDrawer()"><app-icon name="cog" /></a>
      <button (click)="logout()">Logout</button>
    </footer>
  </div>
</div>
